import { useEffect, useRef, useState } from "react";

/* ── Shared assets ─────────────────────────────────────────── */
export const ASSETS = {
  coverImage: "https://customer-assets-rejwkqb3.emergentagent.net/job_88cdfb34-d304-4964-b26e-667fad7c83fb/artifacts/29m62lae_2DS08209.webp",
  mysLogo: "https://customer-assets-rejwkqb3.emergentagent.net/job_88cdfb34-d304-4964-b26e-667fad7c83fb/artifacts/evcaab1m_MYS-26-logo-soft-ivory-CMYK-HD.png",
  ipharraVideo: "https://customer-assets-rejwkqb3.emergentagent.net/job_88cdfb34-d304-4964-b26e-667fad7c83fb/artifacts/25x2jf8u_2013-10-14_Mix_1.mp4",
  ipharraPoster: "/ipharra-poster.jpg",
  s100EcoVideo: "https://customer-assets-rejwkqb3.emergentagent.net/job_88cdfb34-d304-4964-b26e-667fad7c83fb/artifacts/uptaz2n1_Sunreef%20100%20eco%20launch.mp4",
  s100EcoPoster: "/s100eco-poster.jpg",
  ipharra2Video: "https://customer-assets-rejwkqb3.emergentagent.net/job_88cdfb34-d304-4964-b26e-667fad7c83fb/artifacts/fquo38tc_SLide%205%20video.mp4",
  ipharra2Poster: "/ipharra2-poster.jpg",
  wingDark: "https://customer-assets-rejwkqb3.emergentagent.net/job_88cdfb34-d304-4964-b26e-667fad7c83fb/artifacts/eo4kbxkd_SLide%206%20.jpg",
  wingVideo: "https://customer-assets-rejwkqb3.emergentagent.net/job_88cdfb34-d304-4964-b26e-667fad7c83fb/artifacts/s8zqv8zc_Sunreef_WING%202.mp4",
  wingPoster: "/wing-poster.jpg",
  infinityWing: "https://customer-assets-rejwkqb3.emergentagent.net/job_88cdfb34-d304-4964-b26e-667fad7c83fb/artifacts/bquqws3m_Slide%209%200%20infinity%20wing.webp",
  infinitySail: "https://customer-assets-rejwkqb3.emergentagent.net/job_88cdfb34-d304-4964-b26e-667fad7c83fb/artifacts/076yp4p3_Slide%2010%20.webp",
  coverVideo: "https://customer-assets-jai6qajn.emergentagent.net/job_5ef9df75-b51e-4290-85d0-a251c4ec8afa/artifacts/tlqortio_yg7zs1xg_w8moerfb_power%20ad.mp4",
  coverPoster: "https://customer-assets.emergentagent.com/job_f63a99c2-be51-454d-9345-d4172c36d92a/artifacts/r11s450b_80P26E_EXT_009.jpg",
  gdanskVideo: "https://customer-assets.emergentagent.com/job_quiet-yacht-brief/artifacts/1ceg4ufd_gdnaks%20.mp4",
  gdanskPoster: "https://customer-assets.emergentagent.com/job_f63a99c2-be51-454d-9345-d4172c36d92a/artifacts/gdmorol6_80P34_Cam_02.jpg",
  rakShipyard: "https://customer-assets-jai6qajn.emergentagent.net/job_5ef9df75-b51e-4290-85d0-a251c4ec8afa/artifacts/ch1ruk04_Screenshot%202026-08-28%20at%2010.22.58%E2%80%AFAM.webp",
  gdanskShipyard: "https://customer-assets-jai6qajn.emergentagent.net/job_5ef9df75-b51e-4290-85d0-a251c4ec8afa/artifacts/hdi0d86k_Screenshot%202026-08-27%20at%2010.49.58%E2%80%AFAM.webp",
  qaBackdrop: "https://customer-assets-jai6qajn.emergentagent.net/job_5ef9df75-b51e-4290-85d0-a251c4ec8afa/artifacts/zkskibb8_100P05_EXT_004.webp",
  wingAerial: "https://customer-assets-jai6qajn.emergentagent.net/job_5ef9df75-b51e-4290-85d0-a251c4ec8afa/artifacts/r7242qd9_100_INFINITY_ACC_WING_CAM_05.webp",
  wingCloseup: "https://customer-assets-jai6qajn.emergentagent.net/job_5ef9df75-b51e-4290-85d0-a251c4ec8afa/artifacts/8ydjcru2_100_INFINITY_ACC_WING_CAM_07.webp",
  cyfLogo: "https://customer-assets-jai6qajn.emergentagent.net/job_5ef9df75-b51e-4290-85d0-a251c4ec8afa/artifacts/7u3n08ik_cannes-logo%20%282%29.png",
  oceanShot: "https://static.prod-images.emergentagent.com/jobs/5ef9df75-b51e-4290-85d0-a251c4ec8afa/images/e50546d918d6cd4f20fed99fe85749a8c34d5f7ea0d34d5f44d6dd0eaf50a6b0.jpeg",
  wetraVideo: "https://customer-assets-jai6qajn.emergentagent.net/job_5ef9df75-b51e-4290-85d0-a251c4ec8afa/artifacts/abhr47et_Wetra%20web.mp4",
};

/* ── Native reveal hook ────────────────────────────────────── */
export const useReveal = (options = {}) => {
  const ref = useRef(null);
  const [visible, setVisible] = useState(false);
  useEffect(() => {
    const el = ref.current;
    if (!el) return undefined;
    const io = new IntersectionObserver(
      ([entry]) => {
        if (entry.isIntersecting) {
          setVisible(true);
          io.disconnect();
        }
      },
      { threshold: options.threshold ?? 0.15, rootMargin: options.rootMargin ?? "0px" }
    );
    io.observe(el);
    return () => io.disconnect();
  }, [options.threshold, options.rootMargin]);
  return [ref, visible];
};

export const Reveal = ({ children, className = "", delay = 0, testid, as: As = "div", style }) => {
  const [ref, visible] = useReveal();
  const delayCls = delay ? `reveal-d${delay}` : "";
  return (
    <As
      ref={ref}
      className={`reveal ${delayCls} ${className}`}
      data-in={visible ? "true" : "false"}
      data-testid={testid}
      style={style}
    >
      {children}
    </As>
  );
};

/* ── Split-text giant headline ─────────────────────────────── */
const SplitLetters = ({ text }) => {
  const chars = [...text];
  let i = 0;
  return (
    <>
      {chars.map((c, idx) =>
        c === " " ? (
          <span key={idx} className="giant-space">&nbsp;</span>
        ) : (
          <span key={idx} className="giant-letter" style={{ "--i": i++ }}>
            {c}
          </span>
        )
      )}
    </>
  );
};

export const GiantHeadline = ({ line1, line2, accentLine = 2, testid }) => {
  const [ref, visible] = useReveal({ threshold: 0.25 });
  return (
    <h2 ref={ref} className="giant" data-in={visible ? "true" : "false"} data-testid={testid}>
      <span className={`giant-line${accentLine === 1 ? " gold" : ""}`}>
        <SplitLetters text={line1} />
      </span>
      {line2 && (
        <span className={`giant-line${accentLine === 2 ? " gold" : ""}`}>
          <SplitLetters text={line2} />
        </span>
      )}
    </h2>
  );
};

/* ── Chapter marker · .04 — wetra ──────────────────────────── */
export const Chapter = ({ ch, label, testid }) => (
  <span className="chapter" data-testid={testid}>
    <span className="chapter-slug">.{ch}</span>
    {label && <span className="chapter-em">—</span>}
    {label && <span className="chapter-label">{label}</span>}
  </span>
);

export const SlideTop = ({ ch, label, testid }) => (
  <div className="sec-topbar">
    <Chapter ch={ch} label={label} testid={testid} />
    <span className="wordmark wordmark-sm">SUNREEF</span>
  </div>
);

/* ── Placeholder frame for pending assets ──────────────────── */
export const Placeholder = ({ label, note, ratio = "16 / 9", testid }) => (
  <div className="ph-frame" style={{ aspectRatio: ratio }} data-testid={testid}>
    <span className="ph-cross" aria-hidden="true" />
    <span className="ph-label">{label}</span>
    {note && <span className="ph-note">{note}</span>}
  </div>
);
